import { render, staticRenderFns } from "./labelSelect.vue?vue&type=template&id=dae959be&scoped=true&"
import script from "./labelSelect.vue?vue&type=script&lang=js&"
export * from "./labelSelect.vue?vue&type=script&lang=js&"
import style0 from "./labelSelect.vue?vue&type=style&index=0&id=dae959be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae959be",
  null
  
)

export default component.exports